import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';

import Icon from '../../../components/common/atom/Icon';
import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import { Button } from '../../../components/common/atom/Button';
import BabyfaceSalesOptions from './BabyfaceSalesOptions';

import * as PATH from '../../../lib/routes/path';
import TEXT from '../../../lib/text/textSalesBabyface.json';
import { breakpoint } from '../../../lib/style/ThemeStyle';
import useBabyfaceOptions from '../../../Hooks/sales/useBabyfaceOptions';

const BabyfaceSalesDrawer = ({ babyface, isActiveCampaigns, salesOptions }) => {
  const {
    babyfaceDefaultPrice,
    babyfacePrice,
    babyfacePriceWithFastDiscount,
    fastAnalysisDiscount,
    activeCampaigns,
    isShowDrawer,
    setIsShowDrawer,
    isShowPriceInfo,
    setIsShowPriceInfo,
    conversionOption,
    printOption,
    additionalOption,
    productPrice,
    shippingPrice,
    purchaseType,
    doSelectConversionOption,
    doDeleteConversionOption,
    doSelectPrintOption,
    doDeletePrintOption,
    doSelectAdditionalOption,
    doDeleteAdditionalOption,
    doShowPurchaseDrawer,
    doPurchase,
    doGetOrderPrices,
  } = useBabyfaceOptions({ babyface, isActiveCampaigns });

  return (
    <FloatingArea>
      {isShowDrawer && (
        <ExpansionPanel column>
          <ExpansionClose>
            <Icon
              size={30}
              iconName="keyboard_arrow_down"
              style={{ color: '#7a7d86' }}
              onClick={() => setIsShowDrawer(!isShowDrawer)}
            />
          </ExpansionClose>
          <ExpansionBody>
            {salesOptions && (
              <BabyfaceSalesOptions
                babyfaceDefaultPrice={babyfaceDefaultPrice}
                babyfacePrice={babyfacePrice}
                fastAnalysisDiscount={fastAnalysisDiscount}
                activeCampaigns={activeCampaigns}
                salesOptions={salesOptions}
                conversionOption={conversionOption}
                printOption={printOption}
                additionalOption={additionalOption}
                doSelectConversionOption={doSelectConversionOption}
                doSelectPrintOption={doSelectPrintOption}
                doSelectAdditionalOption={doSelectAdditionalOption}
                doDeleteConversionOption={doDeleteConversionOption}
                doDeletePrintOption={doDeletePrintOption}
                doDeleteAdditionalOption={doDeleteAdditionalOption}
              />
            )}
            <Flex
              column
              padding="0 0 1.25rem"
              style={{
                margin: '1.25rem 0 1.563rem',
                border: '1px solid #e6e6e7',
                borderWidth: '1px 0',
              }}
            >
              {doGetOrderPrices().map((item, idx) => (
                <Flex
                  justifyContent="space-between"
                  width="100%"
                  padding="1.25rem 0 0"
                  key={idx}
                >
                  <Text>{item.title}</Text>
                  <Flex alignItems="center">
                    {item.originalPrice && (
                      <>
                        <Text 
                          color="black" 
                          weight="medium"
                          style={{ 
                            textDecoration: 'line-through',
                            marginRight: '0.5rem',
                            color: '#999'
                          }}
                        >
                          {item.originalPrice}
                          {textMonetaryUnit}
                        </Text>
                      </>
                    )}
                    <Text color="black" weight="medium">
                      {item.price}
                      {textMonetaryUnit}
                    </Text>
                  </Flex>
                </Flex>
              ))}
            </Flex>
            <Flex column padding="0 0 1.097rem" alignItems="flex-start">
              <Flex
                justifyContent="space-between"
                width="100%"
                padding="0 0 0.188rem"
              >
                <Flex>
                  <Text style={{ margin: '0.15rem 0.4rem 0 0' }}>
                    {textEstimatedPaymentAmount}
                  </Text>
                  <Icon
                    size={16}
                    iconName="help"
                    style={{ color: '#c7c7c7' }}
                    onClick={() => setIsShowPriceInfo(true)}
                  />
                </Flex>
                <Text size={20} weight="medium" color="orangePink">
                  {(productPrice + shippingPrice).toLocaleString()}
                  {textMonetaryUnit}
                </Text>
              </Flex>
              {purchaseType.guide && (
                <Text color="caption" size={12}>
                  {`${purchaseType.title}: ${purchaseType.guide}`}
                </Text>
              )}
            </Flex>
            {isShowPriceInfo && (
              <PriceInfoBox column>
                <PriceInfoClose>
                  <Icon
                    size={20}
                    iconName="close"
                    onClick={() => setIsShowPriceInfo(false)}
                  />
                </PriceInfoClose>
                <Text color="black" weight="medium">
                  {textInfoEstimatedPaymentAmount}
                </Text>
                <Text
                  style={{ margin: '0.5rem 0 0' }}
                  color="black"
                  size={12}
                  textAlign="center"
                >
                  {parse(textContentEstimatedPaymentAmount)}
                </Text>
              </PriceInfoBox>
            )}
          </ExpansionBody>
        </ExpansionPanel>
      )}
      <ButtonBox>
        {isShowDrawer ? (
          <OrderButton outline={false} width="90%" onClick={() => doPurchase()}>
            {`${purchaseType.title}하기`}
          </OrderButton>
        ) : (
          <>
            {ORDER_BUTTONS.map((item, index) => {
              const { outline, path, title, guide } = item;
              return (
                <React.Fragment key={index}>
                  {outline === buttonPresent ? (
                    <Icon
                      iconName="redeem"
                      style={{ color: '#ff6452', fontSize: '2.5rem' }}
                      onClick={() =>
                        doShowPurchaseDrawer({ path, title, guide })
                      }
                    />
                  ) : (
                    <OrderButton
                      outline={outline}
                      onClick={() =>
                        doShowPurchaseDrawer({ path, title, guide })
                      }
                    >
                      {title}
                    </OrderButton>
                  )}
                </React.Fragment>
              );
            })}
          </>
        )}
      </ButtonBox>
    </FloatingArea>
  );
};

export default BabyfaceSalesDrawer;

const {
  textMonetaryUnit,
  textEstimatedPaymentAmount,
  textInfoEstimatedPaymentAmount,
  textContentEstimatedPaymentAmount,
  buttonPresent,
  buttonPrePurchase,
  buttonOrder,
  notiPrepurchaseGuide,
  notiOrderGuide,
} = TEXT;

const ORDER_BUTTONS = [
  [buttonPresent, PATH.ORDER_PRESENT, buttonPresent, null],
  [true, PATH.ORDER_PRE_PURCHASE, buttonPrePurchase, notiPrepurchaseGuide],
  [false, PATH.ORDER, buttonOrder, notiOrderGuide],
].map((item) => ({
  outline: item[0],
  path: item[1],
  title: item[2],
  guide: item[3],
}));

const FloatingArea = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
  max-width: ${breakpoint}px;
`;

const ExpansionPanel = styled(Flex)`
  justify-content: flex-start;
  position: relative;
  width: 100%;
  height: 73vh;
  padding: 0 1rem 4rem;
  border-radius: 1.5rem 1.5rem 0 0;
  background-color: #ffffff;
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
`;

const ExpansionClose = styled(Flex)`
  align-items: flex-start;
`;

const ExpansionBody = styled.div`
  overflow-y: scroll;
  width: 100%;
`;

export const ButtonBox = styled(Flex)`
  justify-content: space-evenly;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: ${breakpoint}px;
  padding: 0.625rem 0;
  background: #ffffff;
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
  z-index: 20;
`;

const OrderButton = styled(Button)`
  width: ${(props) => props.width || '40%'};
  height: 2.75rem;
  border: ${(props) =>
    props.outline ? `1px solid ${props.theme.color.orangePink}` : 'none'};
  border-radius: 0.375rem;
  background: ${(props) =>
    props.outline
      ? props.theme.color.background
      : props.theme.color.orangePink};
  color: ${(props) =>
    props.outline
      ? props.theme.color.orangePink
      : props.theme.color.background};
`;

const PriceInfoBox = styled(Flex)`
  position: relative;
  padding: 0.625rem 0;
  margin: 0 0 1rem;
  border-radius: 0.5rem;
  background: #f6f6f6;
`;

const PriceInfoClose = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;
